import { createRoutes } from '../../common/routes';

export const routes = createRoutes({
    aliceStandalone: __appConfig.app.links.aliceStandalone,
    applicationUrlRoot: __appConfig.app.urlRoot,
    documentationUrlRoot: __appConfig.app.links.documentation,
    documentationUrlRootYango: __appConfig.app.links.documentationYango,
    assetsRoot: __appConfig.app.assetsRoot,
});
